import RangeExtentsSlider from './range-extents-slider';
export default RangeExtentsSlider;
